export const insertScript = (src: string | null, attributes: Record<string, any> = {}) => {
  return new Promise<void>((resolve, reject) => {
    let script = null;

    if (src) {
      script = document.querySelector(`[src="${src}"]`);
    }

    if (!script && attributes.id) {
      script = document.getElementById(attributes.id);
    }

    if (!script) {
      script = document.createElement("script");
      script.setAttribute("src", src as string);

      script.onload = () => resolve();
      script.onerror = () => reject();

      for (const key in attributes) {
        script.setAttribute(key, attributes[key]);
      }

      const s: HTMLCollection = document.getElementsByTagName("script");
      const ls: Element = s[s.length - 1];
      ls.parentNode?.insertBefore(script, ls.nextSibling);
    } else {
      resolve();
    }
  });
};

export const isIframe = (): boolean => {
  try {
    return window.location.hostname !== window.parent.location.hostname;
  } catch {
    // some browsers can still report iframe while its not really iframe, so to make sure we need embed site with ?iframe param
    return window.location.search.indexOf("iframe") > -1;
  }
};

export const listItemResizer = () => {
  document.querySelectorAll(".model-list, .upcoming-list, .shoots-page, .related-shoots, .model-profile").forEach((list) => {
    const allTitles = [];
    let rowTitles: HTMLElement[] = [];
    let lastTopPosition: number | undefined;
    const items = list.querySelectorAll(".model-item, .shoot-item");
    items.forEach((item) => {
      const topPosition = (item as HTMLElement).offsetTop;

      if (lastTopPosition !== undefined && lastTopPosition !== topPosition) {
        allTitles.push(rowTitles);
        rowTitles = [];
      }

      const title: HTMLElement | null = item.querySelector(".title");

      if (!title) {
        return;
      }

      rowTitles.push(title);
      lastTopPosition = topPosition;
    });

    if (rowTitles.length) {
      allTitles.push(rowTitles);
    }

    allTitles.forEach((titles) => {
      const maxHeight = Math.max.apply(
        null,
        titles.map((title) => {
          return title.scrollHeight;
        }),
      );

      if (maxHeight === 0) {
        return;
      }

      titles.forEach((title) => {
        title.style.height = `${maxHeight}px`;
      });
    });
  });
};

export const scrollIntoElement = (element: HTMLElement) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          observer.disconnect();
        }
      });
    },
    { threshold: 0.1 },
  );

  setTimeout(() => {
    observer.observe(element);
    setTimeout(() => {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 1000);
  }, 100);
};
